<template>
  <div style="display: flex;justify-content: flex-start;">
    <p style="font-size: 13px;padding: 10px;">共计&ensp;{{ total }}&ensp;条</p>
    <el-pagination style="margin-top: 15px;" @current-change="list();"
      @size-change="(val) => { this.size = val; this.list(); }" :current-page.sync="page" :page-sizes="sizes"
      :page-size="size" :total="total" background layout="sizes,prev,pager,next">
    </el-pagination>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1, size: 12, total: 0, sizes: [10, 12, 20, 50, 100, 200, 300, 10000],
    };
  },
  methods: {
    list() {
      this.$parent.$parent.list();
    }
  }
}
</script>